import { graphqlOperation } from 'aws-amplify';
import { listStores } from '../../graphql/queries';
import { graphql } from '../../utils/api';

export const fetchStoresQuery = () => graphql(graphqlOperation(listStores));
